<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
    <input matInput [formControl]="ChildControl" [matAutocomplete]="auto"
           [required]="required">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let res of Results" [value]="res">
            {{res.Value}}
        </mat-option>
    </mat-autocomplete>
    <span matSuffix *ngIf="matSuffix">
        <ng-container *ngTemplateOutlet="matSuffix"></ng-container>
    </span>
</mat-form-field>
